/* eslint-disable i18next/no-literal-string */
import { IButtonStyles, IStackTokens, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { keyframes } from '@fluentui/style-utilities';
import { IAppTheme } from 'common/theme';

const baseline = 8;
const size = {
  xl: baseline * 4,
  lg: baseline * 3,
  md: baseline * 2,
  sm: baseline * 1.5,
  xs: baseline,
  xxs: baseline / 2,
} as const;

export const getStyles = memoizeFunction((theme: IAppTheme, customStyles?: IButtonStyles) => {
  const { appColors, palette } = theme;

  // Note: use neutralGray82 for both themes
  const ghostDotColor = appColors?.neutralGray82;
  const colorAnimation = keyframes({
    '0%': {
      backgroundColor: ghostDotColor,
    },
    '50%': {
      backgroundColor: palette.themeDark,
    },
    '100%': {
      backgroundColor: ghostDotColor,
    },
  });

  const opacityAnimation = keyframes({
    '0%': {
      opacity: 0.5,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.5,
    },
  });

  return mergeStyleSets(
    {
      dot: {
        animationDuration: '1.5s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        borderRadius: '100%',
        height: size.xxs,
        width: size.xxs,

        '&:nth-child(2)': {
          animationDelay: '0.5s',
        },
        '&:nth-child(3)': {
          animationDelay: '1s',
        },
      },
      primary: {
        animationName: opacityAnimation,
        backgroundColor: palette.white,
      },
      ghost: {
        animationName: colorAnimation,
        backgroundColor: ghostDotColor,
      },
      icon: {
        margin: '0px 1px 0px 0px',
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    customStyles
  );
});

export const tokens: IStackTokens = {
  childrenGap: size.xxs,
};
